<template>
  <div class="main">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane" style="height: 100%">
        <left
          :isMore='false'
          :zsgc="true"
          :sousuo="true"
          height="100"
          @abc="reGroup"

        ></left>
      </div>
      <div slot="right" class="demo-split-pane">
        <right ref="right"></right>
      </div>
    </Split>
  </div>
</template>
<script>
import left from "./baojiamubanLeftPerson.vue";
import right from "./baojiamubanRight.vue";
export default {
  components:{left,right},
  data() {
    return {
      split1: '240',
    };
  },
  methods: {
    reGroup(v){
      this.$refs.right.reach(v);
    }
  },
};
</script>
<style>
.demo-tree-render .ivu-tree-title {
  width: 100%;
  background: #333;
}
.formh4 {
  margin-top: 20px;
  margin-bottom: 20px;
}
#zhuanyi {
  height: calc(100% - 110px);
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojiamubanPerson.vue